'use strict';

import 'google';


export default function($log, $rootScope) {
	'ngInject';

	return {
		restrict: 'A',
		require: ['ngModel'],
		scope: {
			lat: '<',
			lng: '<',
			requiredComponents: '<',
		},
		link: link,
	};

	// Returns false if a required component is missing, otherwise returns true
	function validateComponents(requiredComponents) {
		var nbComps = requiredComponents.length;
		return function validate(modelValue) {
			for(var i = 0; i < nbComps; i++) {
				try {
					var componentValue = modelValue[requiredComponents[i]];
				} catch(e) {
					return false;
				}
				if (!componentValue) {
					return false;
				}
			}
			return true;
		};
	}

	function link(scope, element, attrs, ctrls) {
		var ngModelCtrl = ctrls[0];

		// Add a model validator for required components when appropriate
		if (scope.requiredComponents && !Array.isArray(scope.requiredComponents)) {
			$log.warn('`required-components` attribute is not an array.  Ignoring');
		} else if (scope.requiredComponents) {
			ngModelCtrl.$validators.components = validateComponents(scope.requiredComponents);
		}

		// Setup the autocomplete
		var autocomplete = new google.maps.places.Autocomplete(element[0]);
		if (scope.lat && scope.lng) {
			var latlng = new google.maps.LatLng({lat: scope.lat, lng: scope.lng});
			var circle = new google.maps.Circle({center: latlng, radius: 10});
			autocomplete.setBounds(circle.getBounds());
		}

		autocomplete.addListener('place_changed', function() {
			var place = autocomplete.getPlace();
			var addressComponents = place.address_components;
			var nbComps = addressComponents.length;

			function addressComponent() {
				for (var i = 0; i < arguments.length; i++) {
					var name = arguments[i];
					for (var j = 0; j < nbComps; j++) {
						var component = addressComponents[j];
						if (component.types.indexOf(name) !== -1) {
							return component[`short_name`];
						}
					}
				}
				return '';
			}

			// Adheres the brdj location model
			var location;
			if (addressComponents) {
				location = {
					autoclean: false,
					raw: element.val(),
					street_number: addressComponent('street_number'),
					route: addressComponent('route'),
					premise: addressComponent('premise'),
					subpremise: addressComponent('subpremise'),
					locality: addressComponent('locality', 'sublocality'),
					country: addressComponent('country'),
					postal_code: addressComponent('postal_code'),
					administrative_level_1: addressComponent('administrative_area_level_1'),
					administrative_level_2: addressComponent('administrative_area_level_2'),
					administrative_level_3: addressComponent('administrative_area_level_3'),
				};
			} else {
				location = {
					autoclean: false,
					raw: element.val(),
				};
			}

			try {
				location.lat = place.geometry.location.lat().toFixed(8);
				location.lng = place.geometry.location.lng().toFixed(8);
			} catch(e) {
				location.lat = null;
				location.lng = null;
			}

			// Update the model
			ngModelCtrl.$setViewValue(location);
			$rootScope.$digest();
		});
	}
}
